import { setLinkChangeId } from 'qa/src/events/app';
import {
    deselectLinkedGroup,
    selectLinkedGroup,
    selectIssue,
    clearFilters,
} from 'qa/src/events/qa';
import { navigateTableSelect } from 'qa/src/events/route';
import { createLinkedGroup, deleteLinkedIssue } from 'qa/src/events/table';
import {
    getLinkedIssuesUnchecked,
    getLinkedRemote,
    getSelectedLinkedGroup,
} from 'qa/src/queries/qa';
import { LinkedIssues, Issue } from 'qa/src/remote';
import { DIV, NodeOrOptional } from 'sdi/components/elements';
import { divTooltipBottom } from 'sdi/components/tooltip';
import tr from 'sdi/locale';
import { foldRemote } from 'sdi/source';
import { noView } from '.';
import {
    renderButtonDeleteLinkedIssue,
    renderButtonAddLinkedIssue,
    renderButtonAddLinkedGroup,
} from '../buttons';

const renderLinkedRemoteLoading = () =>
    DIV({ className: `issue-field tags` }, 'Chargement des données...');

const renderLinkedRemoteError = (err: string) =>
    DIV({ className: `issue-field tags` }, `Erreur de chargement ${err}`);

const renderDeleteLinkButton = (linkGroup: number, issueId: number) =>
    divTooltipBottom(
        tr.qa('deleteLinkedIssue'),
        {},
        renderButtonDeleteLinkedIssue(() => {
            setLinkChangeId(linkGroup);
            deleteLinkedIssue(issueId);
            deselectLinkedGroup();
        })
    );

const renderAddLinkButton = (linkGroup: LinkedIssues, issueId: number) =>
    divTooltipBottom(
        tr.qa('addLinkedIssue'),
        {},
        renderButtonAddLinkedIssue(() => {
            deselectLinkedGroup();
            setLinkChangeId(linkGroup.id);
            selectIssue(issueId);
            navigateTableSelect('issue', issueId);
        })
    );

export const renderLinkButtons = (linkGroup: LinkedIssues, issueId: number) => {
    if (linkGroup.link === 'MANUAL') {
        return [
            renderAddLinkButton(linkGroup, issueId),
            renderDeleteLinkButton(linkGroup.id, issueId),
        ];
    } else {
        return noView();
    }
};

// const renderCancelLinkButton = (linkGroupId: number, issueId: number) =>
//     divTooltipTop(
//         tr.qa('selectLinkInTable'),
//         {},
//         renderButtonDelete(() => {
//             // setAddLinkStatus(false);
//             // deselectLinkedGroup();
//             // setLinkChangeId(linkGroupId);
//             // navigateToSelection('issue', issueId);
//         }),
//     );

// const renderAddLink = (linkGroupId: number, issueId: number) => {
//     const selectedLinkId = getLinkChangeId().getOrElse(-1);
//     if (selectedLinkId === linkGroupId && getLayout() === 'tableSelect') {
//         return renderCancelLinkButton(linkGroupId, issueId);
//     }
//     else {
//         return renderAddLinkButton(linkGroupId, issueId);
//     }
// };

const renderLinkedIssuesBlock = (id: number) => (l: LinkedIssues) => {
    const title = (() => {
        switch (l.link) {
            case 'OSM_OBJECT':
                return `${l.issues.length} ${tr.qa('linkedObject')}`;
            case 'LOCATION':
                return `${l.issues.length} ${tr.qa('linkedLocation')}`;
            case 'CHANGESET':
                return `${l.issues.length} ${tr.qa('linkedChangeset')}`;
            case 'MANUAL':
                return `${l.issues.length} ${tr.qa('linkedManual')} (grp id:${
                    l.id
                })`;
        }
    })();

    // const issues = catOptions(l.issues.filter(i => i !== id).map(findIssue))
    //     .map(issue => divTooltipTop(
    //         `ID: ${issue.id}\nStatut: ${tr.qa(getStatus(issue))}\Criticité: ${tr.qa(getCriticalityOrUnknown(issue))}`,
    //         {
    //             onClick: () => {
    //                 clearSelectedIssues();
    //                 navigateToSelection('issue', issue.id);
    //             },
    //         },
    //         DIV({
    //             className: 'linked-issue-item',

    //             style: {
    //                 color: getStatusColor(issue.status),
    //             },
    //         }, nameToString('circle'))));

    const selected = getSelectedLinkedGroup().foldL(
        () => '',
        lg => (lg.id === l.id ? 'selected' : '')
    );

    return DIV(
        {
            className: `list-item link-qa ${selected}`,
            onClick: () => {
                clearFilters();
                selectIssue(id);
                selectLinkedGroup(l);
            },
        },
        title
        // DIV({ className: 'linked-issues-content' },
        //     // DIV({ className: 'linked-issues-list' }, ...issues),
        //     DIV({ className: 'linked-issues-actions' },
        //         l.link === 'MANUAL' ? renderAddLinkButton(l.id, id) : noView(),
        //         l.link === 'MANUAL' ? renderDeleteLinkButton(l.id, id) : noView(),

        //         divTooltipTop(
        //             tr.qa('viewLinkedIssuesTable'),
        //             {},
        //             tableIconButton(() => getSelectedLinkedGroup()
        //                 .foldL(
        //                     () => selectLinkedGroup(l),
        //                     lg => lg.id === l.id ? deselectLinkedGroup() : selectLinkedGroup(l)
        //                 ),
        //                 getSelectedLinkedGroup()
        //                     .map(lg => lg.id === l.id ? 'pressed' : '')
        //                     .getOrElse('')),
        //         )
        //     ),
        // ),
    );
};

// export const renderCreateAndAddLink = (issueId: number) => {
//     if (getManualLinkedGroup(issueId).isNone()) {
//         createLinkedGroup(issueId);
//         return getLinkChangeId().map(lid => renderAddLink(lid, issueId));
//     }
//     else {
//         return noView();
//     }

// }

const renderLinkedRemoteSuccess = (id: number, ls: LinkedIssues[]) =>
    DIV(
        {
            className: 'issue-field-value',
        },
        ...ls.map(renderLinkedIssuesBlock(id)),
        renderButtonAddLinkedGroup(() => createLinkedGroup(id))
    );

const renderLinkedIssuesRemote = (id: number) =>
    foldRemote<number[], string, NodeOrOptional>(
        () => DIV({}),
        renderLinkedRemoteLoading,
        renderLinkedRemoteError,
        ls => renderLinkedRemoteSuccess(id, ls.map(getLinkedIssuesUnchecked))
    )(getLinkedRemote(id));

export const renderLinkedIssues = (issue: Issue) =>
    DIV(
        {
            className: `issue-field linked-issues`,
            key: `issue-field-linked-issues`,
        },
        DIV({ className: 'issue-field-label' }, tr.qa('linkedIssues')),
        renderLinkedIssuesRemote(issue.id)
        // getFilterLinked().fold(
        //     DIV({
        //         className: 'issue-field-value',
        //         // onClick: () => setLinkedIssues(issue.linked_issues),
        //     }, tr.qa('seeInTable')),
        //     () => DIV({
        //         className: 'issue-field-value',
        //         onClick: () => clearLinkedIssues(),
        //     }, tr.qa('cancelFilter')),
    );
